import classNames from 'classnames'
import React from 'react'
import Select from 'react-select'
import queryString from 'query-string'
import { getDateOption } from './FilterDate-utils'
import { filterDateOptions } from './FilterDate-constants'
import { NavigateFunction, useNavigate } from 'react-router'
import { useURLParams } from '../../hooks/useURLParams'
import {
  INTERVAL_URL_VALUE,
  PAGE_URL_VALUE,
} from '../../constants/filterURLNames'

interface FilterDateProps {
  className?: string
  navigate: NavigateFunction
  params: { [k: string]: string }
}

export const FilterDate: React.FC<FilterDateProps> = ({ className }) => {
  const filterPrfx = 'filter-param-container'
  const filterCls = classNames(filterPrfx, {
    [`${className}`]: className,
  })
  const navigate = useNavigate()
  const params = useURLParams()
  const date = params[INTERVAL_URL_VALUE]

  const [dateFilter, setDateFilter] = React.useState(getDateOption(date))

  React.useEffect(() => {
    setDateFilter(getDateOption(date))
  }, [date])

  const handleFilterDateChange = (option: any) => {
    setDateFilter(getDateOption(option.value))
    params[INTERVAL_URL_VALUE] = option.value
    params[PAGE_URL_VALUE] = '1'
    navigate({ search: queryString.stringify(params) })
  }

  return (
    <div className={filterCls}>
      <label className={`${filterPrfx}__label`} htmlFor='date'>
        По дате
      </label>
      <Select
        id='date'
        className='react-select-container'
        classNamePrefix='react-select'
        getOptionValue={(option) => `${option.label}`}
        value={dateFilter}
        onChange={handleFilterDateChange}
        options={filterDateOptions}
      />
    </div>
  )
}
